import { render, staticRenderFns } from "./GeofenceNotification.vue?vue&type=template&id=5a0e8ef2&scoped=true&"
import script from "./GeofenceNotification.vue?vue&type=script&lang=ts&"
export * from "./GeofenceNotification.vue?vue&type=script&lang=ts&"
import style0 from "./GeofenceNotification.vue?vue&type=style&index=0&id=5a0e8ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e8ef2",
  null
  
)

export default component.exports